import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import styles from "./sortdropdown.module.scss";

const Filterdropdown = ({
  text,
  SortIcon,
  toggleIcon,
  dropdownItems,
  onSelect,
}) => {
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);

  const toggle = () => setFilterDropdownOpen((prevState) => !prevState);

  return (
    <div className={styles["dropdown_container_wrapper"]}>
      <Dropdown
        isOpen={filterDropdownOpen}
        toggle={toggle}
        className={styles["dropdown_container"]}
      >
        <DropdownToggle className={styles["dropdown_toggle"]}>
          <div className={styles["dropdownToggleDiv"]}>
            <div>
              <img src={SortIcon} alt="sort" />
            </div>
            <div className={styles["paragraphTag"]}>
              <p className={styles["filterLabel"]}>{text}</p>
            </div>
            <div>
              <img src={toggleIcon} alt="icon" />
            </div>
          </div>
        </DropdownToggle>
        {dropdownItems ? (
          dropdownItems
        ) : (
          <DropdownMenu className={styles["dropdown_menu"]}>
            <DropdownItem header>Header</DropdownItem>
          </DropdownMenu>
        )}
      </Dropdown>
    </div>
  );
};

export default Filterdropdown;

// import React, { useState } from "react";
// import {
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
// } from "reactstrap";
// import styles from "./sortdropdown.module.scss";

// const Filterdropdown = ({ text, SortIcon, toggleIcon, dropdownItems }) => {
//   const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);

//   const toggle = (setState) => setState((prevState) => !prevState);
//   return (
//     <div className={styles["dropdown_container_wrapper"]}>
//       <Dropdown
//         isOpen={filterDropdownOpen}
//         toggle={() => {
//           toggle(setFilterDropdownOpen);
//         }}
//         className={styles["dropdown_container"]}
//       >
//         <DropdownToggle className={styles["dropdown_toggle"]}>
//           <div className={styles["dropdownToggleDiv"]}>
//             <div>
//               <img src={SortIcon} alt="sort" />
//             </div>
//             <div className={styles["paragraphTag"]}>
//               <p className={styles["filterLabel"]}>{text}</p>
//             </div>
//             <div>
//               <img src={toggleIcon} alt="icon" />
//             </div>
//           </div>
//         </DropdownToggle>
//         {dropdownItems ? (
//           dropdownItems
//         ) : (
//           <DropdownMenu className={styles["dropdown_menu"]}>
//             <DropdownItem header>Header</DropdownItem>
//           </DropdownMenu>
//         )}
//       </Dropdown>
//     </div>
//   );
// };

// export default Filterdropdown;
